module.exports = __webpack_public_path__ + "static/media/delete.0bb0eeb0.svg";